export class ListActionApprovalRulesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "actionApprovalRules",
            "baseName": "actionApprovalRules",
            "type": "Array<ActionApprovalRule>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListActionApprovalRulesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
